module.exports = ".spinner{width:50px;height:40px;text-align:center;font-size:10px}.spinner-rect{display:inline-block;height:100%;width:6px;margin:0 3px 0 0;background-color:gray;animation:a 1.2s infinite ease-in-out}.spinner-rect2{animation-delay:-1.1s}.spinner-rect3{animation-delay:-1s}.spinner-rect4{animation-delay:-.9s}.spinner-rect5{animation-delay:-.8s}@keyframes a{0%,40%,to{transform:scaleY(.4)}20%{transform:scaleY(1)}}"


//////////////////
// WEBPACK FOOTER
// ./assets/spinner.css
// module id = 23
// module chunks = 1